// SearchAccordion.styled.ts

import styled from "styled-components";

import { device } from "@/utils/sizes";
import { colourScheme } from "@/utils/styling/colours";

export const Container = styled.div`
    width: 100%;
`;

export const Header = styled.header`
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 1rem 0;
    background-color: ${colourScheme.primaryDark};
    box-shadow: 0 4px 6px -1px ${colourScheme.shadow};
`;

export const HeaderContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 0 1rem;
`;

export const HeaderFlex = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
    flex-grow: 1;

    ${device.md} {
        flex-direction: row;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    ${device.md} {
        width: auto;
    }
`;

export const Title = styled.h1`
    font-size: 1.25rem;
    font-weight: bold;
    color: ${colourScheme.secondary};

    ${device.md} {
        font-size: 1.5rem;
    }
`;

export const SearchAndFilter = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 100%;
`;

export const SearchWrapper = styled.div`
    position: relative;
    flex-grow: 1;
`;

export const SheetFooter = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;

    ${device.md} {
        justify-content: space-between;
    }
`;

export const SortSection = styled.div`
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    z-index: 2050;
`;

export const SortOptions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ${device.md} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`;

export const SortBy = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const ActiveFilters = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const MainContent = styled.main`
    width: 100%;
    margin: 0 auto;
    padding: 2rem 1rem;
`;
